export const parseMapRoomCardPictures = (pictures) => {
  const { urls, ...restPictures } = pictures;
  return { ...restPictures, urls: [urls[0]] };
};
